<template>
  <div>
      <div v-if="list.length>0">
        <div v-for="(item,index) in list" :key="index" class="m-tablediv">
            <el-table
              :data="item.isShow ? item.allArr : item.arr "
              style="width: 100%; margin-top: 40px"
              :span-method="item.isShow ? objectSpanMethod : objectSpanMethodHide "
              :show-header="index==0? true :false"
              :header-cell-style="{background: '#f9f9f9', color: '#333'}"
            >
              <el-table-column
                label="商品信息"
                width="220"
                >
                <template slot-scope="scope">
                  <div class="m-c">
                      <div><img class="img" :src="scope.row.goods_img" width="150" height="150" alt /></div>
                      <div class="m-fw">{{ scope.row.goods_name }}</div>
                      <div title="scope.row.store_name">
                        <span>店铺名称:{{ scope.row.store_name }}</span>
                        <img class="logo" v-if="scope.row.platform=='tianmao'" src="../../assets/my/tianmao.png" />
                        <img class="logo" v-if="scope.row.platform=='suning'" src="../../assets/my/suning.png" />
                        <img class="logo" v-if="scope.row.platform=='jingdong'" src="../../assets/my/jd.png" />
                        <img class="logo" v-if="scope.row.platform=='kaola'" src="../../assets/my/kaola.png" />
                        <img class="logo" v-if="scope.row.platform=='taobao'" src="../../assets/my/tb.png" />
                      </div>
                      <div>日常价格:{{ scope.row.daily_price }}</div>
                      <div v-if="scope.row.discount_model==1">折扣方式:无</div>
                      <div v-if="scope.row.discount_model==2">折扣方式:直降</div>
                      <div v-if="scope.row.discount_model==3">折扣方式:满减</div>
                      <div v-if="scope.row.discount_model==4">折扣方式:优惠券</div>
                      <div v-if="scope.row.discount_model==5">折扣方式:满减+优惠</div>
                      <div >优惠后价格:{{ scope.row.kol_special_price }}</div>
                      <div>佣金:{{ scope.row.commission }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="达人带货">
                <template slot-scope="scope">
                  <div v-if="scope.row.head_portrait" class="m-imgdiv">
                    <div><img class="img" :src="scope.row.head_portrait" width="64" height="64" alt /></div>
                    <div>{{ scope.row.nickname }}</div>
                  </div>
                    <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column label="状态">
                <template slot-scope="scope">
                  <div  v-if="scope.row.check_status">
                    <div v-if="scope.row.check_status==0">未知</div>
                    <div v-if="scope.row.check_status==1">待确认</div>
                    <div v-if="scope.row.check_status==2">待上线</div>
                    <div v-if="scope.row.check_status==3">已完成</div>
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column label="带货时间">
                <template slot-scope="scope">
                    <div v-if="scope.row.kol_time_begin"><div>{{scope.row.kol_time_begin.slice(0,10)}}</div>-<div>{{scope.row.kol_time_end.slice(0,10)}}</div></div>
                    <div v-else>-</div>
                </template>
              </el-table-column>
              <el-table-column label="形式">
                <template slot-scope="scope">
                  <div v-if="scope.row.promote_live">
                    <div v-if="scope.row.promote_live==2">混播</div>
                    <div v-if="scope.row.promote_live_special==2">专场</div>
                    <div v-if="scope.row.promote_other==2">其他</div>
                    <div v-if="scope.row.promote_video==2">短视频</div>
                  </div>
                  <div v-else>-</div>
                </template>
              </el-table-column>
            </el-table>
            <template v-if="item.allArr.length>5">
                <div class="m-more" v-if="!item.isShow"><span @click="getMoreProduct(index,item)">更多{{item.allArr.length-5}}位带货达人，详情请戳↓</span></div>
                <div class="m-sq" v-else><span @click="takeBackProduct(index,item)">收起</span></div>
            </template>

        </div>
      </div>
      <div class="not-tip" v-else>
        <img src="../../assets/auth/noauth.png" class="auth-tip" />
        <div>暂无数据～</div>
      </div>
    <!-- 页码 -->
    <pagePagination :pageData="pageData" @pageChange="pageChange"></pagePagination>
  </div>
</template>

<script>
import "./tool.css";
import utils from "../../config/api.js";
import util from "../../utils/util";
import sensors from "sa-sdk-javascript";
import pagePagination from "@/components/page_pagination.vue"
export default {
  name: "launchgoods",
  components:{
    pagePagination
  },
  data() {
    return {
      pageData: {
        count: 0,
        page: 1,
        offset: 5
      },
      api: {
        getLaunchKolGoodsList:"home/getLaunchKolGoodsList",//列表
      },
      formData:{
        check_time_s:"",
        check_time_e:"",
        create_ary:"",
        kolgsid:"",
        goods_name:"",
      },
      list:[],
      kolgsid:"",
      kol_special_price:[],
    };
  },
  // watch: {
  //   $route: {
  //     handler: function() {
  //       if(!this.$route.query.kolgsid){
  //         this.kolgsid='';
  //         this.formData.kolgsid='';
  //         this.formData.page=1;
  //         this.restSeach()
  //         this.getData();
  //       }
  //     },
  //     immediate: true
  //   }
  // },
  created() {
    this.kolgsid=this.$route.query.kolgsid;
    this.getData();
  },
  mounted() {},
  methods: {
    objectSpanMethodHide({ row, column, rowIndex, columnIndex }) {//达人显示条数
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        }else{
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {//达人显示条数
      
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: 99,//达人的length
            colspan: 1,
          };
        }else{
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    //格式化开票时间
    createChangeFn(event) {//申请时间
      this.formData.check_time_s = (event && util.dateFormat(event[0]).full) || "";
      this.formData.check_time_e = (event && util.dateFormat(event[1]).full) || "";
    },
    restSeach(){//重置按钮
      this.formData.check_time_s="";
      this.formData.check_time_e="";
      this.formData.create_ary="";
    },
    getData(){//获取列表信息
      let _this = this;
      let data=this.formData;
      data.kolgsid= this.kolgsid || this.formData.kolgsid;
      data.page = this.pageData.page;
      data.page_size = this.pageData.offset;
      _this.list = [];
      this.$http({
        method: "GET",
        url: _this.api.getLaunchKolGoodsList,
        params: data
      }).then(res => {
        if (res.code == 1) {
          window.scrollTo(0, 0);
          let list = [];
          res.data.data.forEach((deal,i)=>{
            let obj = {
                arr:[],
                allArr:[],
                isShow:false
            }
            let item = {
              kolgsid:deal.kolgsid,
              goods_name:deal.goods_name,
              goods_img: deal.goods_img,
              goods_link: deal.goods_link,
              store_name: deal.store_name,
              platform: deal.platform,
              daily_price: deal.daily_price,
              discount_model: deal.discount_model,
              expect_coupon_price: deal.expect_coupon_price,
              kol_special_price: deal.kol_special_price,
              commission: deal.commission,
            };
            let kol_deal = Object.keys(deal.kol_deal);
            if(kol_deal.length){
              kol_deal.forEach((kol_deal)=>{
                item = {...item, ...deal.kol_deal[kol_deal]}
                obj.allArr.push(item)
                obj.arr.push(item)
              })
            }else{
              obj.allArr.push(item)
              obj.arr.push(item)
            }
             if(obj.arr.length>5){
               obj.arr.length=5;
             }
             list.push(obj)
          })
         _this.pageData.count = res.data.total;
         _this.list = list;

        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    getMoreProduct(index,item){//点击查看更多带货达人
      this.list[index].isShow = true;
    },
    takeBackProduct(index,item){
      this.list[index].isShow = false;
    },
    // 分页改变
    pageChange(page, pageSize){
      this.pageData.page = page;
      this.pageData.offset = pageSize;
      this.getData();
    },
    //按条件搜索
    searchList() {
      this.pageData.page = 1;
      this.getData();
    },
  },
};
</script>
<style  scoped>
.jiange {
  margin: 5px;
}
.m-more{
  text-align: right;
  font-size: 12px;
  line-height: 60px;
}
.m-more span{
  cursor: pointer;
  display: inline-block;
}
.m-sq{
  text-align: right;
  font-size: 12px;
  line-height: 60px;
}
.m-sq span{
  cursor: pointer;
  display: inline-block;
}
.m-fw{
  font-weight: bold;
}
.logo{
  height: 15px;
  width: 15px;
  position: relative;
  top: 2px;
  padding-left: 3px;
}
.m-h90{
  height: 90px;
  line-height: 90px;
}
.m-imgdiv{
  width: 64px;
  text-align: center;
}
.m-c{
  width: 150px;
}
.auth-tip {
  display: block;
  width: 290px;
  height: 270px;
}
.not-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 400px;
  font-size: 14px;
  color: #999;
}
</style>